module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/ai513-4f433e5c7a802c97e2983e72bf0acdfd.jpg";